// ================================================================
// DOM Utilities
// ================================================================

/**
 * escape HTML برای جلوگیری از XSS
 */
export function escapeHtml(str) {
  if (str == null) return '';
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

/**
 * Material Symbol icon
 */
export function icon(name, size = 24) {
  return `<span class="material-symbols-rounded notranslate" translate="no" aria-hidden="true" style="font-size: ${size}px">${name}</span>`;
}

/**
 * Event delegation — برای elementی که هنوز DOM نیست
 */
export function delegate(root, selector, eventType, handler) {
  root.addEventListener(eventType, (e) => {
    const target = e.target.closest(selector);
    if (target && root.contains(target)) {
      handler(e, target);
    }
  });
}
